import barba from '@barba/core';

export default class {
	constructor() {
		barba.hooks.afterOnce((data) => {
			this.setIndex();
			this.initIndex();
		});

		barba.hooks.after((data) => {
			this.setIndex();
			this.initIndex();
		});
	}

	setIndex() {
		let indexWrap = document.createElement("div");
		let postContent = document.querySelector('#js-postContent');
		let firstH2 = "";
		if(postContent) {
			firstH2 = postContent.querySelector('h2');
		}
		if(firstH2) {
			indexWrap.setAttribute('id', 'js-postIndex');
			indexWrap.classList.add('c-blog__single--toc');
			indexWrap.innerHTML = '<div class="c-blog__single--toc-header">目次</div>';
			firstH2.parentNode.insertBefore(indexWrap, firstH2);
		}
	}
	initIndex() {
		let indexWrap = document.querySelector('#js-postIndex');
		if(indexWrap) {
			let postContent = document.querySelector('#js-postContent');
			let hTags = postContent.querySelectorAll('#js-postContent>h2, #js-postContent>h3');

			if (hTags.length > 0) {
    
                let indexList = document.createElement("ol");
                let listSrc = "";
                let h3List = "";    //h3タグを取得しておくための変数
        
                for (let i = 0; i < hTags.length; i++) {
        
                    let theHeading = hTags[i];
                    theHeading.setAttribute('id', "index_id" + i);  //リンクで飛べるようにIDをつける
        
                    if (theHeading.tagName === 'H2') {
        
                        if (h3List !== "") {
                            //h3リストが生成されていれば
                            listSrc += '<ol>' + h3List + '</ol>';
                            h3List = "";
                        } 
        
                        listSrc += '</li><li><a href="#index_id' + i + '">' + theHeading.textContent + '</a>';
        
                    } else if (theHeading.tagName === 'H3') {
        
                        h3List += '<li><a href="#index_id' + i + '">' + theHeading.textContent + '</a></li>';
        
                    }
        
                }
        
                if (h3List !== "") {
                    //最後のリストがh3だった場合
                    listSrc += '<ol>' + h3List + '</ol></li>';
                } else {
                    listSrc += '</li>';
                }
        
                indexList.classList.add('c-blog__single--toc-list')
                indexList.innerHTML = listSrc;
                indexWrap.appendChild(indexList);
        
            }
		}
	}

}